// frontend/src/pages/ConfirmarEmail.jsx
// ═══════════════════════════════════════════════════════════════════
// Página de confirmación de email para leads de la landing page
// Ruta: /confirmar-email/:token
// ═══════════════════════════════════════════════════════════════════
import React, { useEffect, useState,useRef } from "react";
import { useParams, Link } from "react-router-dom";

const ESTADOS = { cargando: "cargando", ok: "ok", error: "error", expirado: "expirado" };

export default function ConfirmarEmail() {
  const { token } = useParams();
  const [estado, setEstado] = useState(ESTADOS.cargando);
  const llamada = useRef(false); // Guard contra double-invoke de React StrictMode

  useEffect(() => {
    if (!token)         { setEstado(ESTADOS.error);   return; }
    if (llamada.current) return; // ya se ejecutó en este montaje
    llamada.current = true;

    fetch(`/api/public/confirmar-email/${encodeURIComponent(token)}`)
      .then(async (res) => {
        if (res.ok)                                    return setEstado(ESTADOS.ok);
        if (res.status === 410 || res.status === 404)  return setEstado(ESTADOS.expirado);
        setEstado(ESTADOS.error);
      })
      .catch(() => setEstado(ESTADOS.error));
  }, [token]);

  return (
    <div style={estilos.pagina}>
      <div style={estilos.card}>
        {/* Logo */}
        <div style={estilos.logo}>eFIT</div>

        {/* ── Cargando ── */}
        {estado === ESTADOS.cargando && (
          <>
            <div style={estilos.spinner} />
            <h2 style={estilos.titulo}>Verificando tu email…</h2>
            <p style={estilos.subtitulo}>Un momento, por favor.</p>
          </>
        )}

        {/* ── Éxito ── */}
        {estado === ESTADOS.ok && (
          <>
            <div style={{ ...estilos.icono, background: "#dcfce7", color: "#16a34a" }}>✅</div>
            <h2 style={{ ...estilos.titulo, color: "#15803d" }}>¡Email confirmado!</h2>
            <p style={estilos.subtitulo}>
              Tu solicitud quedó registrada. Un asesor de <strong>eFIT</strong> se comunicará
              contigo a la brevedad.
            </p>
            <Link to="/" style={estilos.boton}>Volver al inicio</Link>
          </>
        )}

        {/* ── Token expirado ── */}
        {estado === ESTADOS.expirado && (
          <>
            <div style={{ ...estilos.icono, background: "#fef9c3", color: "#ca8a04" }}>⏳</div>
            <h2 style={{ ...estilos.titulo, color: "#b45309" }}>Enlace expirado</h2>
            <p style={estilos.subtitulo}>
              Este enlace de confirmación ya no es válido (expiró en 24 horas).
              Vuelve a completar el formulario para recibir uno nuevo.
            </p>
            <Link to="/" style={{ ...estilos.boton, background: "#f59e0b" }}>Volver al formulario</Link>
          </>
        )}

        {/* ── Error ── */}
        {estado === ESTADOS.error && (
          <>
            <div style={{ ...estilos.icono, background: "#fee2e2", color: "#dc2626" }}>❌</div>
            <h2 style={{ ...estilos.titulo, color: "#b91c1c" }}>Algo salió mal</h2>
            <p style={estilos.subtitulo}>
              No pudimos procesar tu solicitud. Si el problema persiste, escríbenos a{" "}
              <a href="mailto:soporte@efit.com.do" style={{ color: "#6366f1" }}>
                soporte@efit.com.do
              </a>
            </p>
            <Link to="/" style={{ ...estilos.boton, background: "#6b7280" }}>Volver al inicio</Link>
          </>
        )}
      </div>
    </div>
  );
}

const estilos = {
  pagina: {
    minHeight: "100vh",
    background: "#f1f5f9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Arial, sans-serif",
    padding: "24px",
  },
  card: {
    background: "#fff",
    borderRadius: "16px",
    boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
    padding: "48px 40px",
    maxWidth: "460px",
    width: "100%",
    textAlign: "center",
    border: "1px solid #e2e8f0",
  },
  logo: {
    fontSize: "28px",
    fontWeight: "800",
    color: "#6366f1",
    letterSpacing: "-1px",
    marginBottom: "32px",
  },
  spinner: {
    width: "48px",
    height: "48px",
    border: "4px solid #e2e8f0",
    borderTopColor: "#6366f1",
    borderRadius: "50%",
    animation: "spin 0.8s linear infinite",
    margin: "0 auto 24px",
  },
  icono: {
    width: "64px",
    height: "64px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    margin: "0 auto 24px",
  },
  titulo: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 12px",
  },
  subtitulo: {
    color: "#64748b",
    fontSize: "15px",
    lineHeight: "1.6",
    margin: "0 0 32px",
  },
  boton: {
    display: "inline-block",
    background: "#6366f1",
    color: "#fff",
    padding: "12px 32px",
    borderRadius: "8px",
    textDecoration: "none",
    fontWeight: "700",
    fontSize: "15px",
  },
};
